export class ModelObject {
    constructor(initObjectParams) {
        this.authorOrganizationId = null;
    }

    applyInitObjectParams(initObjectParams) {
        if (initObjectParams) {
            const initKeys = Object.keys(initObjectParams);
            if (initKeys.length > 0) {
                for (const key of initKeys) {
                    if (this.hasOwnProperty(key) && initObjectParams[key]) {
                        this[key] = initObjectParams[key]
                    }
                }
            }
        }
    }

    applyData(data) {
        if (data) {
            const dataKeys = Object.keys(data);
            if (dataKeys.length > 0) {
                for (const bKey of dataKeys) {
                    const key = bKey.replace(/_./g, x => x[1].toUpperCase())
                    if (this.hasOwnProperty(key) && data[bKey]) {
                        this[key] = data[bKey]
                    }
                }
            }
        }
    }
}